import styled, { keyframes } from "styled-components";

import { Container } from "./event-card-styles";

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const SkeletonBase = styled.div<{
  width: string | number;
  height: string | number;
}>`
  width: ${(props) =>
    typeof props.width === "number" ? `${props.width}px` : props.width};
  height: ${(props) =>
    typeof props.height === "number" ? `${props.height}px` : props.height};
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 104px;
  animation: ${shimmer} 1.2s linear infinite;
  border-radius: 4px;
`;

const RegisterButtonContainer = styled.div`
  margin-top: auto;
`;

export function EventCardSkeleton() {
  return (
    <Container>
      <div className="mb-4 flex items-center">
        <div className="mr-4">
          <SkeletonBase
            width={96}
            height={64}
            style={{ borderRadius: "4px" }}
          />
        </div>
        <div className="flex flex-col">
          <SkeletonBase
            width={200}
            height={20}
            style={{ marginBottom: "8px" }}
          />
          <SkeletonBase width={150} height={16} />
        </div>
      </div>
      <div className="mb-4 flex">
        <SkeletonBase width="100%" height={16} />
      </div>
      <RegisterButtonContainer>
        <SkeletonBase width={154} height={28} />
      </RegisterButtonContainer>
    </Container>
  );
}
